export enum AccordionNavigationType {
  MENU,
  FOOTER,
}
